"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YourSavingsCardCms = void 0;
var YourSavingsCardCms = /** @class */ (function () {
    function YourSavingsCardCms() {
        this.removeLinkLabel = 'Remove';
        this.totalMonthlyLabel = 'Total monthly savings';
        this.totalOneTimeLabel = 'Total one-time savings';
        this.promoInfoLabel = 'Nice! Your promo code was applied.';
        this.promoModalTitleLabel = 'Offer details';
        this.removeApiErrTxt = "Uh-ho! Something went wrong. Try to remove the promo code again.\n     If the problem persist, please try again later.";
        this.seeOfferDetailsLinkLabel = 'See offer details';
        this.repInfoLabel = 'Sales rep code applied';
        this.seeOfferModalTitleLabel = 'Offer details';
        this.hboMaxLabel = "Get HBO Max\u2122 for 30 days! We'll email you a promo code and details on how to start your trial.";
    }
    return YourSavingsCardCms;
}());
exports.YourSavingsCardCms = YourSavingsCardCms;
//# sourceMappingURL=yourSavingsCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/YourSavingsCard/yourSavingsCard.cms.js
// module id = 565
// module chunks = 8